const videos = document.querySelectorAll('[js-video')

if (videos) {
  for(const video of videos) {
    const parent = video.parentElement
    const iframe = video.querySelector('iframe')
    const btn = parent.querySelector('.single-video-btn')
    const image = parent.querySelector('article-lead_image')

    parent.addEventListener('click', () => {
      video.style.display = 'block'
      
      setTimeout(() => {
        video.style.opacity = 1
        const dataVideo = iframe.dataset.src
        if (dataVideo) iframe.src = `${dataVideo}?autoplay=1`
        else iframe.src = `${iframe.src}?autoplay=1`
      }, 100)
    })

    // btn.addEventListener('click', () => {
    //   video.style.display = 'block'
      
    //   setTimeout(() => {
    //     video.style.opacity = 1
    //     image.style.opacity = 0
    //     iframe.src = `${url}?autoplay=1`
    //   }, 100)
    // })
  }
}